<template>
  <!-- <router-link :to="{ path: '/' + Id +'/' + ApiKey + '/' + Os + '/' + Country + '/?'+ ADV_ID +'&cval='+Cval + LANG + OPTIONAL_PARAMS}"> -->
    <div class="maincard-wrapper"
      :class="{'open': open}"
      :style="styleObject">
      <div v-if="open" class="close-btn" @click="handleView()"><img src="@/assets/close-btn.svg"/></div> 
      <div class="grid-container" @click="!open ? handleView() : null">
        <img class="big-card-img" :src="Advertorial" alt />
        <div class="big-card-text">
  
          <p class="p-card">
              <span class="main-poll-card-title big-card-title w-100 text-truncate d-inline-block" v-html="Title"></span>
                <br/>
           
            <br/>
            <span v-if="!open || $route.query.style !== 'myAppTree'">
            </span>
            <span v-else v-html="$locale.cards.itwillplant+': '+Coins+' '+$locale.cards.trees">
            </span>
          </p>
        </div>
        <button v-if="!open" id="mainButton">
          <div v-if="this.$cookie.get(Id) == null">
            <span v-if="$route.query.style == 'myAppTree'" class="tree-coefficient">{{Coins/Ratio}}</span>
            <span v-else>{{Coins}}</span>
            <img  class="coin-logo img-responsive" src="../assets/gem.svg" />
          </div>
          <div v-else>
            <img class="coin-logo img-responsive done" src="../assets/done.svg"/>
          </div>
        </button>    
      </div>

    </div>
  <!-- </router-link> -->
</template>

<script>
// import DetailsBox from "./DetailsBox.vue";

// import axios from "axios";

export default {
  name: "MainCard",
  data() {
    return {
      LANG:'',
      OPTIONAL_PARAMS:'',
      // max_height:'max-height: 310px',
      open: false,
      styleObject:{
        transform: 'translate(0px,0px)',
        // maxHeight: '310px',
        maxHeight: '19.6rem',
        overflowY: 'hidden',
        position: ''
      }
    };
  },
  props: [
    "Title",
    "Coins",
    "ImgURL",
    "IconURL",
    "Id",
    "ApiKey",
    "Os",
    "Country",
    "Cval",
    "Model",
    "Lang",
    "OptionalParams",
    "Ratio",
    "Advertorial"
// "Open"
  ],

  activated(){
    this.open = false;
  },

  created(){

        /* eslint-disable no-console*/

    if(this.Lang != '') this.LANG = "&lang=" + this.Lang;
    if(this.OptionalParams.length > 0){
      var qElements = '';
      this.OptionalParams.forEach(el=>{
        if( !(el.includes('lang'))  &&!(el.includes('cval')) &&!(el.includes('name')) &&!(el.includes('advertising_id')) &&!(el.includes('totalCoins'))){
            qElements+='&'+el;
        }
      })
      this.OPTIONAL_PARAMS = qElements;
    }
  },

  // mounted(){

  //   var that = this;
  //   var isBottom = false;
  //   document.addEventListener('touchstart', handleTouchStart, false);        
  //   document.addEventListener('touchmove', handleTouchMove, false);
                                                       
  //   var yDown = null;

  //   function getTouches(evt) {
  //     return evt.touches ||             // browser API
  //           evt.originalEvent.touches; // jQuery
  //   }                                                

  //   function handleTouchStart(evt) {
  //       const firstTouch = getTouches(evt)[0];                                                                          
  //       yDown = firstTouch.clientY; 
  //       // isBottom = that.$el.scrollTop >= that.$el.scrollHeight - that.$el.offsetHeight;

  //       var elem = document.querySelector("#bottomFlag");
  //       var bounding = elem.getBoundingClientRect();
  //       isBottom = (
  //         bounding.top >= 0 &&
  //         bounding.left >= 0 &&
  //         bounding.bottom <=
  //           (window.innerHeight + 0.5 ||
  //             document.documentElement.clientHeight + 0.5)
  //       )
  //       console.log("bottom")
  //       // console.log("scrolltop >= scrollheight - offsetheight: $s",window.scrollY, that.$el.scrollHeight, that.$el.offsetHeight);                                   
  //   }                                     

  //   function handleTouchMove(evt) {
  //       if (! yDown ) {
  //           return;
  //       }
                                  
  //       var yUp = evt.touches[0].clientY;

  //       var yDiff = yDown - yUp;

  //       console.log("yDiff: $s, yDown: $s, yUp: $s",yDiff,yDown,yUp);

  //       if ( yDiff > 0 && isBottom) {
  //           /* up swipe */ 
  //           console.log('swipe up');
  //           // if(yDiff > 15)
  //             that.handleView();
  //       } else { 
  //           /* down swipe */
  //           console.log('swipe down');
  //       }    

  //       /* reset values */

  //       yDown = null;                                             
  //   }
  // },

  methods: {
    emit: function(eventname){
      this.$emit(eventname, this.Adv_id,this.Title,this.Description,this.IconURL,this.ApiKey,this.FastActions,this.ImgURLs,this.Coins);
      this.$cookie.set(this.Id, "1");
    },
    getSubtitle: function(element) {
      var subtitle = "";

      if (element.length != 0) {
        if (this.$route.query.lang) {
          element.forEach(el => {
            if (el.Language == this.$route.query.lang) subtitle = el.Subtitle;
          });
        } else subtitle = element[0].Subtitle;
      }

      return subtitle;
    },

    handleView: function(){
    
    if(window.isMobile()){
     this.open = !this.open;
      if(this.open){
        
        // document.body.style.height = '100%'
        //let viewportOffset = el.target.getBoundingClientRect(); //this take clicked element's bounding client rect that in this case leads to positioning problems
        let viewportOffset = this.$el.getBoundingClientRect();  //so we use the whole component element
        
        document.body.style.top = '-' + window.scrollY + 'px';
        // document.body.style.position = 'fixed';
        document.body.style.overflowY = 'hidden';

        this.styleObject.transform = 'translate('+ viewportOffset.left * -1 +'px, '+ viewportOffset.top * -1 +'px)';
        this.styleObject.maxHeight = document.documentElement.clientHeight+'px';
        this.styleObject.overflowY = 'scroll';
        // this.styleObject.position = 'fixed';

        console.log('scrollY: '+window.scrollY,'viewportOffset.left '+viewportOffset.left+'viewportOffset.top '+viewportOffset.top);
      }else{
        // document.body.style.height = ''
        this.styleObject.transform = 'translate(0px, 0px)';
        this.styleObject.overflowY = 'hidden';
        this.styleObject.position = '';

        let scrollY = document.body.style.top;
        document.body.style.top = '';
        document.body.style.position = '';
        document.body.style.overflowY = 'scroll';
        window.scrollTo(0, parseInt(scrollY) * -1);
      }
    // }else{
    //   console.log('web')
    }else{
      this.emit('open-store');
    }
  },
    printPosition: function(){
      console.log(this.$el.scrollTop);
    },
  },
  components:{

  }

};
</script>
<style scoped lang="scss">
  .grid-container{
    cursor: pointer;
    position: relative;
    max-height: 50%;
    display: grid;
    grid-template-columns: 3fr 1fr;
    // grid-template-rows: 2fr 1fr;
    grid-template-rows: 12.8rem 1fr;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    /* background-color: white; */
    /* border-radius: 25px; */
  }
  .card-expansion{
    border-radius: 25px;
  }

  .maincard-wrapper{
    position: relative;
    /* max-height: 50%; */
    /* display: grid; */
    /* grid-template-columns: 3fr 1fr; */
    /* grid-template-rows: 2fr 1fr; */
    min-height: 365px!important;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background-color: white;
    border-radius: 25px;
    // -webkit-box-shadow: 5px 5px 10px rgba(190,190,190, 0.16), 5px 5px 10px rgba(190,190,190, 0.23);
    // -ms-box-shadow: 5px 5px 10px rgba(190,190,190, 0.16), 5px 5px 10px rgba(190,190,190, 0.23);
    // -o-box-shadow: 5px 5px 10px rgba(190,190,190, 0.16), 5px 5px 10px rgba(190,190,190, 0.23);
    // box-shadow: 5px 5px 10px rgba(190,190,190, 0.16), 5px 5px 10px rgba(190,190,190, 0.23);
    margin: 3%;
    // overflow: hidden;
    transition: all .5s cubic-bezier(.6,0,.45,1.3);
    // transition: max-height 0.5s cubic-bezier(0, 1, 0, 1);

    &.open{
      z-index: 100;
      border-radius: 0;
      border: 0;
      width: 100vw;
      height: 100vh;
      // transition: max-height 5s ease-in-out;
      transition: all .5s cubic-bezier(.6,0,.45,1.3);
    }

    .big-card-img, .p-card, .description, .actions-container{
      pointer-events: none;
    }
  }

  .submitB{
    position: relative!important;
    width: 95%!important;
    border-radius: 25px!important;
    padding: 4%!important;
    margin-bottom: 0.6rem;
  }


  .description{
    text-align: left;
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .description-clamp{
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 80%;
    overflow: hidden;
  }

 
</style>
